import { type StoredNotification } from "../types";

/** Texto curto exibido na lista/painel. */
export function notificationTitle(n: StoredNotification): string {
  switch (n.type) {
    case "BrokerJoined":
      return `${n.payload.brokerName} entrou para a equipe`;
    case "LicenseActivated":
      return `Licença ativada para ${n.payload.brokerName}`;
    case "SeatsLow":
      return `Plano ${n.payload.planName} com poucos seats`;
    case "SupportReplied":
      return `Suporte respondeu ${n.payload.ticketCode}`;
  }
}

/** Linha secundária com detalhes. */
export function notificationSubtitle(n: StoredNotification): string | null {
  switch (n.type) {
    case "SeatsLow":
      return `${n.payload.availableSlots} seat(s) disponível(is)`;
    case "SupportReplied":
      return n.payload.subject;
    default:
      return null;
  }
}

/** Rota associada à notificação. */
export function notificationRoute(n: StoredNotification): string {
  switch (n.type) {
    case "BrokerJoined":
      return "/brokers";
    case "LicenseActivated":
      return "/brokers";
    case "SeatsLow":
      return "/brokers";
    case "SupportReplied":
      return `/support/${n.payload.ticketId}`;
  }
}
